import agreementPriceIncrease from './agreement-price-increase.js';
import agreement from './agreement.js';
import companyZus from './company-zus';
import crmFormType from './crm-form-type.js';
import crmPartner from './crm-partner';
import crm from './crm.js';
import documentsDelivery from './documents-delivery.js';
import grandParentScopeCrm from './grand-parent-scope-crm.js';
import industryType from './industry-type.js';
import invoice from './invoice.js';
import mailTemplates from './mail-templates';
import mail from './mail.js';
import crmRecipientEmails from './mailing/crm-recipient-emails';
import mailFooter from './mailing/mail-footer.js';
import mailGroupReceiver from './mailing/mail-group-receiver.js';
import mailGroup from './mailing/mail-group.js';
import mailTemplate from './mailing/mail-template.js';
import mailingSettings from './mailing/mailing-settings.js';
import mailing from './mailing/mailing.js';
import publicImages from './mailing/public-images.js';
import priceList from './price-list.js';
import subscriptionSettlementItem from './subscription-settlement-item.js';
import subscriptionSettlement from './subscription-settlement.js';
import templateBasicPriceList from './template-basic-price-list';
import templateBasicPriceListType from './template-basic-price-list-type';
import unitTypes from './unit-types';

export default {
  agreement,
  agreementPriceIncrease,
  crmRecipientEmails,
  companyZus,
  crmFormType,
  crm,
  crmPartner,
  documentsDelivery,
  grandParentScopeCrm,
  industryType,
  invoice,
  mail,
  mailing,
  mailingSettings,
  mailGroup,
  mailGroupReceiver,
  mailFooter,
  mailTemplate,
  priceList,
  subscriptionSettlementItem,
  subscriptionSettlement,
  templateBasicPriceList,
  templateBasicPriceListType,
  unitTypes,
  mailTemplates,
  publicImages,
};
